import React, { useEffect, useState } from "react";
import api from "@/lib/apiClient";
import SEO from "@/components/SEO";

export default function MissionVision() {
  const [c, setC] = useState({});
  useEffect(() => { api.get("/pages/mission_vision").then(({ data }) => setC(data.content || {})).catch(() => {}); }, []);
  return (
    <div className="fade-in">
      <SEO title="Mission & Vision — NPST" description="The institutional mission, vision and core values of the National Public Service Trust." canonical={`${window.location.origin}/mission-vision`} />
      <section className="border-b border-npst-line paper-texture">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="label-eyebrow text-npst-gold mb-3">Institutional Purpose</div>
          <h1 className="font-serif text-4xl sm:text-6xl font-semibold text-npst-ink tracking-tight">Mission & Vision</h1>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div className="border-l-2 border-npst-gold pl-8">
          <div className="label-eyebrow text-npst-gold mb-4">Mission</div>
          <p className="font-serif text-2xl text-npst-ink leading-relaxed">{c.mission}</p>
        </div>
        <div className="border-l-2 border-npst-navy pl-8">
          <div className="label-eyebrow text-npst-navy mb-4">Vision</div>
          <p className="font-serif text-2xl text-npst-ink leading-relaxed">{c.vision}</p>
        </div>
      </section>
      {c.core_values?.length > 0 && (
        <section className="bg-npst-bgAlt border-y border-npst-line">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <div className="label-eyebrow text-npst-gold mb-8">Core Values</div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-npst-line border border-npst-line rounded-md overflow-hidden">
              {c.core_values.map((v, i) => (
                <div key={v} className="bg-npst-bg p-8"><div className="font-mono text-xs text-npst-gold mb-3">{String(i + 1).padStart(2, "0")}</div><div className="font-serif text-2xl text-npst-ink">{v}</div></div>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
